export default __webpack_public_path__ + "static/media/app_dashboard.c6dc47e4.png";